export default {
    panelWidth:340,
    resultItem:308,
    warningMessage:340
}
